import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, FileText, Stethoscope, Download } from "lucide-react";

const HistoryItem = ({ item, onPdf }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
      <div className="flex w-full items-center gap-3 px-4 py-3.5">
        <button
          data-testid={`history-toggle-${item.id}`}
          onClick={() => setOpen((o) => !o)}
          className="flex min-w-0 flex-1 items-center gap-3 text-left transition-colors hover:opacity-80"
        >
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-100">
            <FileText className="h-4 w-4 text-slate-500" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold text-slate-900">{item.title}</p>
            <p className="flex items-center gap-1.5 text-xs text-slate-500">
              <Stethoscope className="h-3 w-3" />
              {item.doctor}
            </p>
          </div>
          <span className="font-mono-num text-xs font-semibold text-slate-400">{item.date}</span>
          <ChevronDown
            className={`h-4 w-4 text-slate-400 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
          />
        </button>
        {onPdf && (
          <button
            data-testid={`history-pdf-${item.id}`}
            onClick={() => onPdf(item.id)}
            title="Baixar PDF do atendimento"
            className="flex shrink-0 items-center gap-1.5 rounded-lg border border-slate-200 px-2.5 py-1.5 text-xs font-semibold text-slate-600 transition-colors hover:bg-slate-50"
          >
            <Download className="h-3.5 w-3.5" /> PDF
          </button>
        )}
      </div>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
          >
            <p className="whitespace-pre-wrap border-t border-slate-100 bg-slate-50/50 px-4 py-3.5 text-sm leading-relaxed text-slate-600">
              {item.summary}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const HistoricoTab = ({ history, onPdf }) => {
  if (!history || history.length === 0) {
    return (
      <div className="rounded-xl border border-dashed border-slate-200 py-12 text-center text-sm text-slate-400">
        Sem histórico de consultas para este paciente.
      </div>
    );
  }
  return (
    <div className="space-y-2.5" data-testid="history-list">
      {history.map((item) => (
        <HistoryItem key={item.id} item={item} onPdf={onPdf} />
      ))}
    </div>
  );
};
